/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_SAL_CLIENTS_ITEM = {
  id: 'sales_clients',
  screenId: 'met-sal-clients',
  label: 'Clientes',
  description: 'Ranking, categorías y detalle por cliente.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro: 'Identificás qué clientes y grupos concentran más facturación en el período.',
      },
      {
        title: 'Pestañas',
        bullets: [
          'Ranking — clientes con más ventas en el período.',
          'Categorías de clientes — ventas por grupo dentro de una categoría de clientes.',
          'Por cliente — buscá un cliente y ves su detalle e historial.',
        ],
      },
      {
        title: 'Período',
        paragraphs: [
          'Elegí el rango con atajos o fechas personalizadas. En categorías podés unificar monedas.',
        ],
      },
    ],
  },
}
